import {useEffect, useRef} from "react";

import {useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";

/**
 * Hook that listens for when preferences flow completes for REGISTER_PROPERTY_PLAN.
 * When the flow closes after user saves preferences, it triggers the callback to show plan download modal.
 */
export const usePlanDownloadModal = (onFlowComplete: () => void) => {
    const registrationFlowState = useAppSelector((state) => state.registrationFlow);
    const previousFlowActiveRef = useRef(false);
    const wasRegisterPropertyPlanRef = useRef(false);

    useEffect(() => {
        const wasActive = previousFlowActiveRef.current;
        const isActive = registrationFlowState.isActive;
        const userSource = registrationFlowState.userSource;

        if (isActive && userSource === UserSource.REGISTER_PROPERTY_PLAN) {
            wasRegisterPropertyPlanRef.current = true;
        }

        if (wasActive && !isActive && wasRegisterPropertyPlanRef.current) {
            onFlowComplete();
            wasRegisterPropertyPlanRef.current = false;
        }

        previousFlowActiveRef.current = isActive;
    }, [registrationFlowState.isActive, registrationFlowState.userSource, onFlowComplete]);
};
import {useEffect, useRef} from "react";

import {useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";

/**
 * Hook that listens for when preferences flow completes for REGISTER_PROPERTY_PLAN.
 * When the flow closes after user saves preferences, it triggers the callback to show plan download modal.
 */
export const usePlanDownloadModal = (onFlowComplete: () => void) => {
    const registrationFlowState = useAppSelector((state) => state.registrationFlow);
    const previousFlowActiveRef = useRef(false);
    const wasRegisterPropertyPlanRef = useRef(false);

    useEffect(() => {
        const wasActive = previousFlowActiveRef.current;
        const isActive = registrationFlowState.isActive;
        const userSource = registrationFlowState.userSource;

        if (isActive && userSource === UserSource.REGISTER_PROPERTY_PLAN) {
            wasRegisterPropertyPlanRef.current = true;
        }

        if (wasActive && !isActive && wasRegisterPropertyPlanRef.current) {
            onFlowComplete();
            wasRegisterPropertyPlanRef.current = false;
        }

        previousFlowActiveRef.current = isActive;
    }, [registrationFlowState.isActive, registrationFlowState.userSource, onFlowComplete]);
};
